export const apikey = 'api:5ZhcVxN1&1S9';

export const recaptchaSecret = '6LdZLL0ZAAAAAMFxirax5pgtS9DUxY5i0WTlOTta';

export const recaptchaSitekey = '6LdZLL0ZAAAAAMtD6ptXxR3RpT2AP1_oFWLxXO1Q';
